<div class="feed-card-container">
    <!-- @if (application.submittedPosts?.length > 1) { -->
    @if (application.submittedPosts?.length > 0) {
    <div class="fan-wrapper">
        @for (post of application.submittedPosts; track post.id; let i = $index; let count = $count) {
        @if (hasThumbnail(post.videoId)) {
        @if (post.videoId ) {
        <img (click)="viewPost(post)" [src]="getThumbnail(post.videoId)" alt="Submitted post" class="fan-card"
            [style.transform]="getFanTransform(i, count)" [style.z-index]="i + 1">
        }
        @else if (!hasThumbnail(post.videoId) && post.videoId) {
        <div class="border-2 border-red-500 size-full" [style.transform]="getFanTransform(i, count)"
            [style.z-index]="i + 1">

            <!-- <atom-video-thumbnail [videoUrl]="post.fullUrl" [videoFormat]="1"
                [thumbnailURL]="getThumbnail(post.videoId)"></atom-video-thumbnail> -->

            <atom-video-thumbnail [videoUrl]="post.fullUrl"
                [thumbnailURL]="post.thumbnailURL ? post.thumbnailURL : undefined"
                [cdnKey]="post.thumbnailCdnKey ? post.thumbnailCdnKey : undefined" [videoFormat]="1">
            </atom-video-thumbnail>
        </div>
        }
        }
        @else {
        <img src="../../../../../assets/images/placeholder.jpeg" alt="Submitted post" class="fan-card"
            [style.transform]="getFanTransform(i, count)" [style.z-index]="i + 1">
        }
        }
    </div>
    } @else {

    }

    <div class="flex flex-row items-center justify-start space-x-2">
        <div class="shrink-0">
            <img [src]="imageService.getImageSource(application.creator.photoURL, 'gallery')" alt=""
                class="size-8 rounded-full bg-gray-800 outline -outline-offset-1 outline-white/10" />
        </div>
        <div class="min-w-0 flex-1">
            <p class="text-sm font-semibold text-primary">
                <a class="hover:underline">{{ application.creator.firstName }} {{ application.creator.lastName.charAt(0)
                    }}</a>
            </p>
            <p class="text-xs text-secondary">
                {{ getHandleAndNetwork() }}
            </p>
        </div>
    </div>
</div>